import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FunctionsIcon from '@mui/icons-material/Functions';
import SegmentIcon from '@mui/icons-material/Segment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import UndoIcon from '@mui/icons-material/Undo';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import AppsIcon from '@mui/icons-material/Apps';
import TimerIcon from '@mui/icons-material/Timer';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { useTranslation } from 'react-i18next';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';

import { Separator, MainRemote, Segmentbuttons, FooterRemote } from './styles';
import { CommandButton, BottomNavigations } from '../../components';
import { COMMANDS, COMMANDS_NAME } from '../../types/commandsList';

function Remote() {
	const { i18n } = useTranslation();

	return (
		<>
			<Separator />
			<MainRemote>
				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.PREVIOUS_PAGE}
						name={COMMANDS_NAME.PREVIOUS_PAGE}
						text={i18n.t('previousBtn')}
						icon={<ArrowBackIosIcon />}
					/>

					<CommandButton
						id={COMMANDS.NEXT_PAGE}
						name={COMMANDS_NAME.NEXT_PAGE}
						text={i18n.t('nextBtn')}
						icon={<ArrowForwardIosIcon />}
						alignRight
					/>
				</Segmentbuttons>

				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.DISPLAY_CUMULATIVE_RESULTS}
						name={COMMANDS_NAME.DISPLAY_CUMULATIVE_RESULTS}
						text={i18n.t('resultsComulatedBtn')}
						icon={<FunctionsIcon />}
					/>

					<CommandButton
						id={COMMANDS.REAL_TIME}
						name={COMMANDS_NAME.REAL_TIME}
						text={i18n.t('resultsInstantBtn')}
						icon={<SegmentIcon />}
						alignRight
					/>
				</Segmentbuttons>

				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.DISPLAY_RANKING}
						name={COMMANDS_NAME.DISPLAY_RANKING}
						text={i18n.t('rankingBtn')}
						icon={<TrendingUpIcon />}
					/>

					<CommandButton
						id={COMMANDS.HIDE_RESULTS}
						name={COMMANDS_NAME.HIDE_RESULTS}
						text={i18n.t('hideResultsBtn')}
						icon={<UndoIcon />}
						alignRight
					/>
				</Segmentbuttons>

				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.SHOW_HIDE_CHRONO}
						name={COMMANDS_NAME.SHOW_HIDE_CHRONO}
						text={i18n.t('timerBtn')}
						icon={<TimerIcon />}
					/>

					<CommandButton
						id={COMMANDS.RESET_QUESTION_ANSWERS}
						name={COMMANDS_NAME.RESET_QUESTION_ANSWERS}
						text={i18n.t('deleteResponsesBtn')}
						icon={<DeleteIcon />}
						alignRight
					/>
				</Segmentbuttons>

				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.SEATING_PLAN}
						name={COMMANDS_NAME.SEATING_PLAN}
						text={i18n.t('roomPlanBtn')}
						icon={<AppsIcon />}
					/>

					<CommandButton
						id={COMMANDS.QUIT}
						name={COMMANDS_NAME.QUIT}
						text={i18n.t('quit')}
						icon={<CancelIcon />}
						alignRight
					/>
				</Segmentbuttons>

				<Segmentbuttons>
					<CommandButton
						id={COMMANDS.QR_CODE}
						name={COMMANDS_NAME.QR_CODE}
						text={i18n.t('qrCode')}
						icon={<QrCodeScannerIcon />}
						alignRight
					/>

					<CommandButton
						id={COMMANDS.NOT_VOTING}
						name={COMMANDS_NAME.NOT_VOTING}
						text={i18n.t('nonVotant')}
						icon={<PlaylistRemoveIcon />}
						alignRight
					/>
				</Segmentbuttons>
			</MainRemote>

			<FooterRemote>
				<BottomNavigations current="remote" />
			</FooterRemote>
		</>
	);
}

export default Remote;
